function _createForOfIteratorHelper(o, allowArrayLike) {var it;if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {if (it) o = it;var i = 0;var F = function F() {};return { s: F, n: function n() {if (i >= o.length) return { done: true };return { done: false, value: o[i++] };}, e: function e(_e) {throw _e;}, f: F };}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}var normalCompletion = true,didErr = false,err;return { s: function s() {it = o[Symbol.iterator]();}, n: function n() {var step = it.next();normalCompletion = step.done;return step;}, e: function e(_e2) {didErr = true;err = _e2;}, f: function f() {try {if (!normalCompletion && it.return != null) it.return();} finally {if (didErr) throw err;}} };}function _unsupportedIterableToArray(o, minLen) {if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);}function _arrayLikeToArray(arr, len) {if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {arr2[i] = arr[i];}return arr2;}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import { GlobalManagerMixin } from './GlobalManagerMixin';
var FADE_DURATION = 416; // This value came from the hig component
var CYCLE_DURATION = 1000; // This value came from the hig componen

var NUM_SIDES = 10; // Number of sides for the loading polygon spinner
var SIZE = 72;
var THICKNESS = 6.75;

var SPINNER_SCALE = 0.5;
export var ForgeLogoSpinner = /*#__PURE__*/function () {
  function ForgeLogoSpinner(viewer) {_classCallCheck(this, ForgeLogoSpinner);
    this.viewer = viewer;
    this.setGlobalManager(this.viewer.globalManager);
    this.domElement = null;
    this._step = this._step.bind(this);
  }_createClass(ForgeLogoSpinner, [{ key: "createDom", value: function createDom(

    container) {var _this = this;
      var _document = this.getDocument();
      this.domElement = _document.createElement('div');
      this.domElement.className = 'forge-spinner';
      this._initTransform = "translate(-50%, -50%) scale(".concat(SPINNER_SCALE, ")");
      this.domElement.style.transform = this._initTransform.slice();
      var svg = this._createSvgElement('svg');
      svg.setAttribute('width', '242');
      svg.setAttribute('height', '242');
      svg.setAttribute('viewBox', "0 0 ".concat(SIZE, " ").concat(SIZE));
      svg.setAttributeNS('http://www.w3.org/2000/xmlns/', 'xmlns:xlink', 'http://www.w3.org/1999/xlink');
      this.domElement.appendChild(svg);

      // Create the outer and inner polygon points
      var data = this._createWheelPointData(NUM_SIDES, SIZE, THICKNESS);

      this._createMask(data);

      // Add the first polygon to the svg. This is the same as the outer polygon in the image mask
      var firstPolygon = this._createSvgElement('polygon');
      firstPolygon.setAttribute('mask', 'url(#mask)');
      svg.appendChild(firstPolygon);
      this._addPoints(data.outerPoints, firstPolygon);

      // Create the colored segments. There will be 2 * NUM_SIDES number of segments
      this._createSegments(data);

      var img = _document.createElement('img');
      img.src = Autodesk.Viewing.Private.getResourceUrl('res/ui/forge-logo.png');
      var that = this;
      this._onResize = this._onResize.bind(this);
      // Add the resize event listener once the forge logo image is loaded.
      img.onload = function () {
        // Initial resize when the forge logo png is loaded.
        // The _onResize method requires the bounding box of the spinner wrapper
        _this._onResize();
        _this._initResize = true;
        _this.viewer.addEventListener(Autodesk.Viewing.VIEWER_RESIZE_EVENT, _this._onResize);
      };
      this.domElement.appendChild(img);
      container && container.appendChild(this.domElement);
      this.domElement.style.display = 'none';

      return this.domElement;
    }

    /**
       * Creates a svg element.
       * @param {String} tag - element tag
       * @private
       */ }, { key: "_createSvgElement", value: function _createSvgElement(
    tag) {
      var _document = this.getDocument();
      return _document.createElementNS('http://www.w3.org/2000/svg', tag);
    }

    /**
       * Returns the SVG element
       * @private
       */ }, { key: "_getSvg", value: function _getSvg()
    {
      return this === null || this === void 0 ? void 0 : this.domElement.getElementsByTagNameNS('http://www.w3.org/2000/svg', 'svg')[0];
    }

    /**
       * Creates an SVG mask for the polygon progress wheel. This will make the inner polygon transparent.
       * @param {*} data
       * @private
       */ }, { key: "_createMask", value: function _createMask(
    data) {
      var svg = this._getSvg();
      var defs = this._createSvgElement('defs');
      var mask = this._createSvgElement('mask');
      mask.id = 'mask';

      defs.appendChild(mask);
      svg.appendChild(defs);
      // Create the outer polygon for the mask
      var polygon = this._createSvgElement('polygon');
      polygon.style['opacity'] = 0.15;
      polygon.style['fill'] = '#FFF';
      mask.appendChild(polygon);
      this._addPoints(data.outerPoints, polygon);

      // Create the inner polygon for the mask
      var endPolygon = this._createSvgElement('polygon');
      mask.appendChild(endPolygon);
      this._addPoints(data.innerPoints, endPolygon);
    }

    /**
       * Animation function
       * @param {Number} timestamp
       * @private
       */ }, { key: "_step", value: function _step(
    timestamp) {
      if (!this.startTime) this.startTime = timestamp;
      var elapsed = timestamp - this.startTime;
      var elapsedThisCycle = elapsed % CYCLE_DURATION;

      this._setSegmentOpacities(elapsedThisCycle);
      var _window = this.getWindow();

      this._animId = _window.requestAnimationFrame(this._step);
    } }, { key: "_stop", value: function _stop()

    {
      if (this._animId) {
        // Stop the animation
        var _window = this.getWindow();
        _window.cancelAnimationFrame(this._animId);
        this._animId = null;
      }
    }

    /**
       * Set the opacity of the triangular segments
       * @param {*} elapsedThisCycle
       * @private
       */ }, { key: "_setSegmentOpacities", value: function _setSegmentOpacities(
    elapsedThisCycle) {var _this2 = this;
      this.segments.forEach(function (segment, i) {
        var index = Math.abs(i - _this2.segments.length) - 1;
        var eachSegment = segment;

        eachSegment.style.opacity = _this2._getSegmentOpacity(index, elapsedThisCycle);
      });
    }

    /**
       * Calculate the segment's opacity value
       * @param {*} index
       * @param {*} elapsedThisCycle
       * @private
       */ }, { key: "_getSegmentOpacity", value: function _getSegmentOpacity(
    index, elapsedThisCycle) {
      var segmentFadeStartTime = index * (CYCLE_DURATION / this.segments.length);

      // Fade continuing from previous cycle
      if (segmentFadeStartTime + FADE_DURATION > CYCLE_DURATION && elapsedThisCycle < FADE_DURATION) {
        return ((elapsedThisCycle + CYCLE_DURATION - segmentFadeStartTime) / FADE_DURATION - 1) * -1;
      }

      // Fade has finished
      if (elapsedThisCycle < segmentFadeStartTime || elapsedThisCycle > segmentFadeStartTime + FADE_DURATION) {
        return 0;
      }

      // Fading
      return Math.abs((elapsedThisCycle - segmentFadeStartTime) / FADE_DURATION - 1);
    }

    /**
       * Returns an array of segement elements.
       * @private
       */ }, { key: "_getSegments", value: function _getSegments()
    {
      return Array.from(this.domElement.querySelectorAll('.segment'));
    }

    /**
       * Adds points to the supplied polygon
       * @param {Number[][]} points - Matrix of points
       * @param {SVGPolygonElement} polygon - polygon element
       * @private
       */ }, { key: "_addPoints", value: function _addPoints(
    points, polygon) {var _iterator = _createForOfIteratorHelper(
      points),_step2;try {for (_iterator.s(); !(_step2 = _iterator.n()).done;) {var value = _step2.value;
          var svg = this._getSvg();
          var point = svg.createSVGPoint();
          point.x = value[0];
          point.y = value[1];
          polygon.points.appendItem(point);
        }} catch (err) {_iterator.e(err);} finally {_iterator.f();}
    }

    /**
       * Creates a polygon with numSides, size and thickness of the polygon.
       * @param {Number} numSides
       * @param {Number} size
       * @param {Number} thickness
       * @returns {Object} - data object containing the outerPolygon and innerPolygon points.
       * @private
       */ }, { key: "_createWheelPointData", value: function _createWheelPointData(
    numSides, size) {var thickness = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
      var center = size / 2;
      var Xcenter = size / 2;
      var Ycenter = size / 2;
      var data = { outerPoints: [], innerPoints: [] };
      for (var i = 1; i <= numSides; i++) {
        data.outerPoints.push([
        Xcenter + center * Math.cos(i * 2 * Math.PI / numSides),
        Ycenter + center * Math.sin(i * 2 * Math.PI / numSides)]);


        data.innerPoints.push([
        Xcenter + (center - thickness) * Math.cos(i * 2 * Math.PI / numSides),
        Ycenter + (center - thickness) * Math.sin(i * 2 * Math.PI / numSides)]);

      }
      return data;
    }

    /**
       * Creates colored triangles inside of the wheel polygon
       * @param {Object} data - returned value from _createWheelPointData
       * @private
       */ }, { key: "_createSegments", value: function _createSegments(
    data) {var _this3 = this;var
      outerPoints = data.outerPoints,innerPoints = data.innerPoints;
      var svg = this._getSvg();
      var createSegmentPolygon = function createSegmentPolygon(points, cssClass) {
        var polygon = _this3._createSvgElement('polygon');
        addClass(polygon, 'segment');
        addClass(polygon, cssClass);
        _this3._addPoints(points, polygon);
        svg.appendChild(polygon);
      };

      // Iterate over the polygons points and create two triangles for each polygon side.
      for (var i = outerPoints.length - 1; i >= 0; --i) {
        var p1 = outerPoints[i],
        p2 = outerPoints[i - 1],
        p3 = innerPoints[i],
        p4 = innerPoints[i - 1];

        if (i === 0) {
          p2 = outerPoints[outerPoints.length - 1];
          p4 = innerPoints[outerPoints.length - 1];
        }

        createSegmentPolygon([p1, p2, p3], 'light-blue');
        createSegmentPolygon([p3, p4, p2], 'dark-blue');
      }
    }

    /**
       * Fade the domElement out.
       * @private
       */ }, { key: "_fadeOut", value: function _fadeOut()
    {var _this4 = this;
      var opacity = 1; // initial opacity
      var timer = setInterval(function () {var _this4$domElement;
        if (!((_this4$domElement = _this4.domElement) === null || _this4$domElement === void 0 ? void 0 : _this4$domElement.style)) {
          clearInterval(timer);
          return;
        }

        if (opacity <= 0.1) {
          clearInterval(timer);
          _this4.domElement.style.display = 'none';
        }
        _this4.domElement.style.opacity = opacity;
        opacity -= opacity * 0.1;
      }, 1);
    } }, { key: "show", value: function show()

    {
      if (this.domElement) {
        this.domElement.style.display = 'block';
        this.domElement.style.opacity = 1;
        this.segments = this._getSegments();
        this._step(1);
      }
    } }, { key: "hide", value: function hide()

    {var _this5 = this;
      if (this.domElement) {
        this._hide = function (event) {
          // Stop the spinner
          _this5._stop();
          if (event.model.is3d()) {
            // Fade the spinner out
            _this5._fadeOut();
          } else {
            // For 2d, the model is loaded right away.
            _this5.domElement.style.opacity = 0;
            _this5.domElement.style.display = 'none';
          }
        };

        var models = this.viewer.impl.modelQueue().getModels();
        if (models.length === 0) {
          // Add an event listener
          this.viewer.addEventListener(Autodesk.Viewing.MODEL_ADDED_EVENT, this._hide, { once: true });
        } else {
          this._hide({ model: models[0] });
        }
      }
    } }, { key: "destroy", value: function destroy()

    {
      if (this.domElement.parentElement) {
        this.domElement.parentElement.removeChild(this.domElement);
      }
      this.domElement = null;
      this.viewer.removeEventListener(Autodesk.Viewing.VIEWER_RESIZE_EVENT, this._onResize);
    } }, { key: "_onResize", value: function _onResize()

    {var _this$domElement, _this$domElement$styl;
      if (this._initResize) {
        this._initResize = false;
        return;
      }
      var spinner = this.domElement;
      if (!spinner) return;

      // Do not calculate the scale when the spinner is not visible
      if (spinner.style.display == 'none') return;

      var parent = spinner.parentElement;
      if (!parent) return;

      var parentBB = parent.getBoundingClientRect();
      var spinnerBB = spinner.getBoundingClientRect();

      var tolerance = Math.max(spinnerBB.width / parentBB.width, (spinnerBB.height + 350) / parentBB.height);

      var transform = (_this$domElement = this.domElement) === null || _this$domElement === void 0 ? void 0 : (_this$domElement$styl = _this$domElement.style) === null || _this$domElement$styl === void 0 ? void 0 : _this$domElement$styl.transform;
      if (!transform) return;

      if (tolerance > 0.8) {
        var regex = /[-+]?scale\(\d*\.\d+|\d+\)/;
        var scale = regex.exec(transform);
        // Check if the scale is present
        if (scale.length > 0) {
          var val = scale[0].split('scale(')[1];
          var newScale = Number((val / tolerance).toFixed(4));
          var newTransform = transform.replace(regex, "scale(".concat(newScale));
          // Only apply the transform if it is not the same and if the new scale is less than the original scale
          if (newTransform != this.domElement.style.transform && newScale <= SPINNER_SCALE && newScale > 0.2) {
            this.domElement.style.transform = newTransform;
          }
        }
      } else if (this.domElement.style.transform != this._initTransform) {
        this.domElement.style.transform = this._initTransform;
      }
    } }]);return ForgeLogoSpinner;}();


function addClass(elm, cssClass) {
  if (!!elm.classList) {
    elm.classList.add(cssClass);
  } else {
    // https://caniuse.com/#search=classList
    // IE11 does not implement classList on <svg>
    var appliedClasses = elm.getAttribute('class') || '';
    appliedClasses = !appliedClasses.split(' ').includes(cssClass) ? "".concat(
    appliedClasses, " ").concat(cssClass) :
    appliedClasses;
    elm.setAttribute('class', appliedClasses);
  }
}

GlobalManagerMixin.call(ForgeLogoSpinner.prototype);